<span
  class="info-tooltip"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggle($event)"
  (mouseenter)="open()"
  (mouseleave)="scheduleClose()"
  (keydown.enter)="toggle($event)"
  tabindex="0"
  role="button"
  [attr.aria-label]="'More information' + (heading ? ' about ' + heading : '')"
>
  <mat-icon class="info-icon">info</mat-icon>
</span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayHasBackdrop]="false"
>
  <div
    class="info-popover"
    (mouseenter)="open()"
    (mouseleave)="scheduleClose()"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    @if (heading) {
      <div class="info-popover-heading">{{ heading }}</div>
    }
    <div class="info-popover-body">{{ description }}</div>
  </div>
</ng-template>
